import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLang } from "../i18n";

export function scrollToId(href) {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20 });
  else el.scrollIntoView({ behavior: "smooth" });
}

const LINKS = [
  { href: "#services", label: { en: "The Craft", it: "I Servizi" }, testid: "nav-link-the-craft" },
  { href: "#calculator", label: { en: "Estimate", it: "Preventivo" }, testid: "nav-link-estimate" },
  { href: "#portfolio", label: { en: "Portfolio", it: "Portfolio" }, testid: "nav-link-portfolio" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const { lang, setLang, L } = useLang();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(href), 500);
    } else {
      scrollToId(href);
    }
  };

  return (
    <header
      data-testid="main-navbar"
      className={`sticky top-0 z-50 transition-colors duration-500 border-b ${
        scrolled ? "bg-[#FBF9F3]/90 backdrop-blur-xl border-[#C9A84C]/25" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-2.5">
          <span className="font-display text-3xl leading-none tracking-tight text-[#0E3B33]">DA</span>
          <span className="mono-tech text-[#A8853B]">Creations Atelier</span>
        </Link>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={l.testid}
              onClick={() => go(l.href)}
              className="mono-tech text-[#4A5248] transition-colors duration-300 hover:text-[#0E3B33]"
            >
              {L(l.label)}
            </button>
          ))}
          <Link
            to="/contact"
            data-testid="nav-link-contact"
            className="mono-tech text-[#4A5248] transition-colors duration-300 hover:text-[#0E3B33]"
          >
            {L({ en: "Contact", it: "Contatti" })}
          </Link>
          <Link
            to="/portal"
            data-testid="nav-link-portal"
            className="mono-tech text-[#4A5248] transition-colors duration-300 hover:text-[#0E3B33]"
          >
            {L({ en: "Client Area", it: "Area Clienti" })}
          </Link>
        </nav>
        <div className="flex items-center gap-5">
          <div className="flex items-center gap-1.5 text-sm" data-testid="lang-toggle">
            <button
              data-testid="lang-en-btn"
              onClick={() => setLang("en")}
              className={`transition-colors ${lang === "en" ? "font-semibold text-[#0E3B33]" : "text-[#8A8F82] hover:text-[#0E3B33]"}`}
            >
              EN
            </button>
            <span className="text-[#C9A84C]">|</span>
            <button
              data-testid="lang-it-btn"
              onClick={() => setLang("it")}
              className={`transition-colors ${lang === "it" ? "font-semibold text-[#0E3B33]" : "text-[#8A8F82] hover:text-[#0E3B33]"}`}
            >
              IT
            </button>
          </div>
          <Link to="/contact" data-testid="nav-start-project-btn" className="ember-btn !py-2.5 !px-5 text-sm">
            {L({ en: "Start a project", it: "Inizia un progetto" })}
          </Link>
        </div>
      </div>
    </header>
  );
}
